import React from 'react';
import styled from 'styled-components';

import { OfficeInList } from '~/components/page/Settings/Profile/components/FormContainer';

import FormFields from './components/FormFields';
import AnimatedBlock from '~/components/atom/AnimatedBlock';
import Catalog from '~/Catalog';
import Form from '~/components/organism/Forms/Form';
import Validation from '~/util/Validation';
import { UserDetailsFormData } from '~/components/page/Settings/Profile';
import FormSaveBar from '../SaveBar/components/FormSaveBar';
import useCurrentUser from '~/hooks/useCurrentUser';

type Props = {
  officesList: Array<OfficeInList>;
  userId?: string;
  initialValues: { email: string; phone: string };
  onFormSubmit?: (formData: UserDetailsFormData) => void;
  readOnly?: boolean;
};

const text = {
  phoneValidation: Catalog.invalidPhone,
  contactInfo: 'Contactgegevens',
};

const UserDetailsForm: React.FCC<Props> = ({
  officesList,
  userId,
  onFormSubmit,
  initialValues,
  readOnly,
}) => {
  const me = useCurrentUser();
  const validate = ({ phone }: UserDetailsFormData): { phone?: string } => {
    const errors: { phone?: string } = {};
    if (!Validation.Phone.isValid(phone)) {
      errors.phone = text.phoneValidation;
    }

    return errors;
  };

  return (
    <AnimatedBlock title={text.contactInfo} dataTestId="user-details-block">
      <Form
        onSubmit={onFormSubmit ? onFormSubmit : () => {}}
        validate={validate}
        initialValues={initialValues}
      >
        {({ handleSubmit, form, submitError }) => (
          <StyledForm
            id="user-details-form"
            onSubmit={handleSubmit}
            data-testid="user-details-form"
          >
            {submitError ? (
              <div data-testid="sign-in-error-message">{submitError}</div>
            ) : null}
            <FormFields
              officesList={officesList}
              readOnly={readOnly}
              onFormChange={form.change}
              userId={userId}
              mayEdit={userId === me.id}
            />

            {<FormSaveBar inBlockComponent />}
          </StyledForm>
        )}
      </Form>
    </AnimatedBlock>
  );
};

const StyledForm = styled.form<{}>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export default UserDetailsForm;
